import type { ReactNode } from 'react'

import { type CreditCardItem } from '@webapp/modules/accounts-payable/entities/CreditCardItem'
import { type ReconcileMatch } from '@webapp/modules/accounts-payable/entities/ReconcileMatch'
import { useMatchedTransactionListPresenter } from './useMatchedTransactionListPresenter'
import { MatchedTransactionList } from '../../views/MatchedTransactionList'

export interface IMatchedTransactionListPresenterProps {
  sessionId: number
  /** Card currency label for the cleared-balance summary */
  currencyName: string
  /** Empty-state link navigates to the Unmatched tab (FS routing, BHV-039) */
  onBeginMatching: () => void
  /** Slot composing Edit item (view mode) / Unmatch item from siblings (ADR-9) */
  renderRowMenu: (item: CreditCardItem, match: ReconcileMatch) => ReactNode
}

export const MatchedTransactionListPresenter = ({
  sessionId,
  currencyName,
  onBeginMatching,
  renderRowMenu,
}: IMatchedTransactionListPresenterProps) => {
  const {
    data: { confirmedMatches, clearedBalance },
    states: { isLoading },
  } = useMatchedTransactionListPresenter({ sessionId })

  return (
    <MatchedTransactionList
      matches={confirmedMatches}
      clearedBalance={clearedBalance}
      currencyName={currencyName}
      isLoading={isLoading}
      onBeginMatching={onBeginMatching}
      renderRowMenu={renderRowMenu}
    />
  )
}

MatchedTransactionListPresenter.displayName = 'MatchedTransactionListPresenter'
